import React from 'react'
import {connect} from 'react-redux'

import {
  PRESENCE_LABELS,
  ROLES
} from '../shared/config/constants'

import setCurrentUserPresence from '../shared/data/setters/current_user_presence'
import setCurrentUserRole from '../shared/data/setters/current_user_role'

import PresenceIndicator from '../shared/presence_indicator'
import SlidingMenu from '../shared/sliding_menu'

class CurrentUserSlidingMenu extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      isOpen: this.props.isOpen
    }
  }

  componentWillReceiveProps (nextProps) {
    this.setState({isOpen: nextProps.isOpen})
  }

  setPresence (presence) {
    presence = parseInt(presence, 10)
    this.props.onPresenceItemClick(presence)

    this.props.onActionMenuClose()
  }

  onExpertModeSwitchClicked (role) {
    this.props.onExpertModeSwitchClicked(role)
    setTimeout(() => this.props.onActionMenuClose(), 400)
  }

  renderPresenceMenu() {
    let presenceMap = Object.keys(PRESENCE_LABELS)
    presenceMap.reverse()

    return (
      presenceMap.map((key) => {
        return (
          <div key={key} className='sliding-menu-item' onClick={() => this.setPresence(key)}>
            <PresenceIndicator presence={parseInt(key, 10)} />
            {PRESENCE_LABELS[key]}
          </div>
        )
      })
    )
  }

  renderSettingsMenu () {
    if (this.props.currentUser) {
      let settingsItems = [
        <div key={0} className='sliding-menu-seperator' />,
        <div key={1} className='sliding-menu-item'>
          <a href={this.props.currentUser.profileUrl} target='_blank' onClick={this.props.onActionMenuClose}>
            <i className='icon-indicator rc-icon-user' />
            <span>Profile</span>
          </a>
        </div>
      ]

      if (this.props.currentUser.role === ROLES.EXPERT) {
        settingsItems.push(
          <div key={2} className='sliding-menu-item' onClick={() => this.onExpertModeSwitchClicked(ROLES.AUTHOR)}>
            <i className='icon-indicator rc-icon-shuffle' />
            <span>Writer mode</span>
          </div>
        )
      }
      else if (this.props.currentUser.role === ROLES.AUTHOR) {
        settingsItems.push(
          <div key={2} className='sliding-menu-item' onClick={() => this.onExpertModeSwitchClicked(ROLES.EXPERT)}>
            <i className='icon-indicator rc-icon-shuffle' />
            <span>Expert mode</span>
          </div>
        )
      }

      return settingsItems
    }
  }

  shouldShowSubMenu () {
    if (this.props.currentUser &&
        (this.props.currentUser.role === ROLES.EXPERT || this.props.currentUser.role === ROLES.AUTHOR)) {
      return true
    }

    return false
  }

  render () {
    let classNames = 'current-user-menu'
    let height
    let isVisible = false
    if (!this.state.isOpen) classNames += ' hidden'

    if (this.state.isOpen) {
      height = 149
      isVisible = true
      if (this.shouldShowSubMenu()) height += 37
    }

    return (
      <SlidingMenu className={classNames} top={this.props.top} isVisible={isVisible} height={height}>
        {this.renderPresenceMenu()}
        {this.renderSettingsMenu()}
      </SlidingMenu>
    )
  }
}

CurrentUserSlidingMenu.defaultProps = {
  onActionMenuClose: () => {}
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.get('currentUser') ? state.get('currentUser').toObject() : null
  }
}

const mapDispatchToProps = () => {
  return {
    onPresenceItemClick: (presence) => setCurrentUserPresence(presence),
      onExpertModeSwitchClicked: (role) => setCurrentUserRole(role)
  }
}

const CurrentUserSlidingMenuContainer = connect(
  mapStateToProps, mapDispatchToProps
)(CurrentUserSlidingMenu)

export default CurrentUserSlidingMenuContainer



/** WEBPACK FOOTER **
 ** ./modules/shared/current_user_sliding_menu.js
 **/